import React, { PureComponent } from 'react';
import { IReducerState } from '../states/renditionStates';
import { connect } from 'react-redux';
import $ from 'jquery';
import _ from 'lodash';
import * as HTML_RENDITION from '../utils/general/general';
import * as deviceInfoService from '../utils/general/deviceInfoService';

interface IMainPageCopyTextProps {
    source?: any;
    newCopyURLData: any;
    initialData: any;
}

export class MainPageCopyText extends PureComponent<IMainPageCopyTextProps, any> {

    constructor(props: IMainPageCopyTextProps) {
        super(props);
    }

    public componentDidMount() {
        const { initialData } = this.props;
        if (HTML_RENDITION.parseToBoolean(initialData.enable_copy) && initialData.user_type == 'E') {
            $(document).on("mouseenter", "#leftMenuCopyTabLi", function () {
                $('#copyText').css("display", "none");
            });
        }
    }

    public addLink(that: any, newCopyURLData: any, e: any) {
        let lastTimeText = "";
        const selection = window.getSelection();
        let copyTextContainerFlag = true;
        const copyText = $('#copyText');
        if (that.getSelectionHtml() !== "") {
            copyTextContainerFlag = false;
            // Don't apply "text copy" rule for contents that are copied outside document text area
            const isDocumentText = $(e.target).parents("#contentPane");
            if (isDocumentText.length == 0) return;

            const pageX = e.pageX;
            let pageY = e.pageY;
            if (deviceInfoService.isIE()) {
                const scrollY = document.documentElement.scrollTop || document.body.scrollTop;
                pageY = e.clientY + scrollY;
            }
            pageY = pageY - 40;

            const xPercent = (pageX / (($(window) as any).width()) * 100);

            copyText.css("left", xPercent + '%');
            copyText.css("top", pageY);
            copyText.css("position", "absolute");
            if (copyText.is(":visible") && lastTimeText == that.getSelectionHtml()) {
                copyText.css("display", "none");
            } else {
                copyText.css("display", "block");
            }
            // Get the selected text and append the extra info
            if (!document.getElementById('copyTextContainer')) {
                const newdiv = document.createElement('div');
                const att = document.createAttribute("id");
                att.value = "copyTextContainer";
                newdiv.setAttributeNode(att);
                newdiv.setAttribute("role", "region");
                newdiv.setAttribute("aria-labelledby", "copy text");
                newdiv.style.position = 'absolute';
                newdiv.style.left = '-99999px';
                // insert the container, fill it with the extended text, and define the new selection
                document.body.appendChild(newdiv);
            }
            const pagelink = '<br/><br/>Read more at: ' + newCopyURLData.copyURL;
            if (document.getElementById('copyTextContainer')) {
                (document.getElementById('copyTextContainer') as HTMLElement).innerHTML = that.getSelectionHtml() + pagelink;
            }
            lastTimeText = that.getSelectionHtml();
        }
        if (e.target.id == "copyText") {
            setTimeout(() => {
                (selection as any).selectAllChildren(document.getElementById('copyTextContainer'));
                document.execCommand('copy');
            }, 500);
        }
        if (copyTextContainerFlag) {
            copyText.css("display", "none");
        }
    }

    public registerCopyEvent(newCopyURLData: any) {
        const that = this;
        if (document.addEventListener) {
            document.addEventListener("mouseup", (e) => this.addLink(that, newCopyURLData, e));
        }
    }

    public copyTextFunc() {
        const pagelink = '<br/><br/>Read more at: ' + document.location.href;
        const copyTextContainerDiv = (document.getElementById("copyTextContainer") as any).innerHTML + pagelink;
        document.execCommand('copy', false, copyTextContainerDiv);
        $('#copyText').css("display", "none");
    }

    public getSelectionHtml(): any {
        let html = "";

        if (typeof window.getSelection != "undefined") {
            const sel: any = window.getSelection();
            if (sel.rangeCount) {
                const container = document.createElement("div");
                for (let i = 0, len = sel.rangeCount; i < len; ++i) {
                    container.appendChild(sel.getRangeAt(i).cloneContents());
                }
                html = container.innerHTML;
            }
        } else if (typeof (document as any).selection != "undefined") {
            if ((document as any).selection.type == "Text") {
                html = (document as any).selection.createRange().htmlText;
            }
        }
        return html;
    }

    public updateVendorCitisBestCiraDocToken (shortUrl: string) {
        try {
            if (!_.isEmpty(shortUrl) && HTML_RENDITION.isOpenedFromCitisBest) {
                const ciraDocToken = shortUrl.split('ciraDocToken=')[1];
                window.parent?.CITIS_BEST.updateCiraDocToken(ciraDocToken);
            }
        } catch (e) {
            console.log(e);
        }
    }

    public render() {
        const { initialData, newCopyURLData } = this.props;

        if (HTML_RENDITION.parseToBoolean(initialData.enable_copy) && initialData.user_type == 'E' && newCopyURLData) {
            this.registerCopyEvent(newCopyURLData);
        }

        if (!_.isEmpty(newCopyURLData)) {
            this.updateVendorCitisBestCiraDocToken(newCopyURLData.copyURL);
        }

        return (
            <div id="copyText" onClick={this.copyTextFunc} role="button" aria-label={initialData.copy_text_message} tabIndex={0}>
                {initialData.copy_text_message}
            </div>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        newCopyURLData: state.asyncStateReducer.copyURLData,
        initialData: state.asyncStateReducer.initialData,
    };
};

export default connect(mapStateToProps)(MainPageCopyText);
